export default __webpack_public_path__ + "static/media/53t.d6a3a022.jpg";